export const ORDER = {
  ASCENDING: "ascending",
  DESCENDING: "descending",
};

export const orderFormatting = {
  [ORDER.ASCENDING]: (id: string) => id,
  [ORDER.DESCENDING]: (id: string) => `-${id}`,
};
